import Rollbar from 'rollbar';

let rollbar: Rollbar;

export interface UpdateRollbarConfig {
  userId?: string;
}

function update(config: Rollbar.Configuration) {
  rollbar = rollbar ? rollbar.configure(config) : new Rollbar(config);
  return rollbar;
}

export function updateRollbar({ userId }: UpdateRollbarConfig): Rollbar {
  const config: Rollbar.Configuration = {
    accessToken: process.env.REACT_APP_ROLLBAR_API_KEY,
    environment: process.env.NODE_ENV,
    captureUncaught: process.env.NODE_ENV !== 'development',
    captureUnhandledRejections: process.env.NODE_ENV !== 'development',
    codeVersion: process.env.REACT_APP_VERSION,
    captureIp: false,
    payload: {
      person: {
        id: userId ?? null,
      },
      client: {
        javascript: {
          // TODO: use code_version
          // code_version: process.env.SOME_VERSION_ENV_VAR,
          // Optionally have Rollbar guess which frames the error was
          // thrown from when the browser does not provide line
          // and column numbers.
          guess_uncaught_frames: true,
        },
      },
    },
  };
  return update(config);
}

export function updateRollbarContext({ context }: { context: string }): Rollbar {
  const config: Rollbar.Configuration = {
    payload: {
      context,
    },
  };
  return update(config);
}

export function getRollbar(): Rollbar {
  if (!rollbar) updateRollbar({});
  return rollbar;
}

export const LEVEL_DEBUG = 'debug';
export const LEVEL_INFO = 'info';
export const LEVEL_WARN = 'warn';
export const LEVEL_ERROR = 'error';
export const LEVEL_CRITICAL = 'critical';
export type LEVEL = typeof LEVEL_CRITICAL | typeof LEVEL_DEBUG | typeof LEVEL_ERROR | typeof LEVEL_INFO | typeof LEVEL_WARN;
